jQuery(document).ready(function ($) {
	/******************************************
    QTY Selector ( Simple quantity box increase / decrease )
   ******************************************/

	// PDP / PLP
	$('body').on('click', '.js-qty:not(.js-qty--cart)', function (e) {
		e.preventDefault();
		var $this = $(this);
		var $parent = $this.parent();
		var qtyInput = $parent.find('input');
		var qtyInputVal = qtyInput.val();
		const maxVal = parseInt(
			$(this).closest('.qty').find('input').attr('max')
		);
		qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;

		if ($this.hasClass('js-qty--plus')) {
			qtyInputVal++;
			qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
		} else {
			qtyInputVal--;
			qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
		}

		if (qtyInputVal > maxVal && maxVal > 0) {
			alert('Quantity entered exceeds available inventory.');
			$(this).closest('.qty').find('input').val(maxVal);
			qtyInputVal = maxVal; // ← make sure price uses capped value
		}

		if ($('.float__actions').length) {
			$('.qty input').val(qtyInputVal);
		} else {
			qtyInput.val(qtyInputVal);
		}

		// ← ADD THIS: recalculate ATC button price
		updateATCPrice(qtyInputVal);
	});

	function updateATCPrice(qty) {
		var $priceSpan = $('.btn--atc .price');
		var basePrice = parseInt($priceSpan.attr('data-price'));

		if (!basePrice || isNaN(qty)) return;

		var total = basePrice * qty;

		// Format as money (e.g. $145.00)
		var formatted = (total / 100).toLocaleString('en-US', {
			style: 'currency',
			currency: 'USD'
		});

		$priceSpan.find('span').text(formatted);
	}

	$('body').on('input', '[sm-rc-quantity-selector]', function () {
		const qty = parseInt($(this).val());
		const maxVal = parseInt($(this).attr('max'));

		if (qty > maxVal) {
			alert('Quantity entered exceeds available inventory.');
			$(this).val(maxVal);
		}
	});

	// MAIN CART

	// Allow typing of input qty for update
	var timer;
	$('.col__qty, .mobile-stuff').on('keyup', '.qty input', function () {
		var $this = $(this);
		var newVal = $this.val();
		var lineKey = $this.closest('.cart-row').attr('data-key');

		// clear the previous timer
		clearTimeout(timer);

		// create a new timer with a delay of 300ms seconds,
		// if the keyup is fired before the 300ms secs then the timer will be cleared
		timer = setTimeout(function () {
			updateCartItemQuantity(lineKey, newVal);
		}, 300);
	});

	function updateCartItemQuantity(lineItemKey, newQuantity) {
		return fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify({
				id: lineItemKey, // line item key or line number
				quantity: newQuantity,
			}),
		})
			.then((res) => res.json())
			.then((cart) => {
				location.reload();
				return cart;
			});
	}

	$('.col__qty, .mobile-stuff').on('click', '.js-qty--cart', function (e) {
		e.preventDefault();

		var $this = $(this);
		var qtyInput = $this.closest('.qty').find('input');
		var qtyInputVal = qtyInput.val();
		qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;
		var lineNum = $this.closest('.cart-row').attr('data-linenum');
		var lineKey = $this.closest('.cart-row').attr('data-key');

		if ($this.hasClass('js-qty--plus')) {
			qtyInputVal++;
			qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
		} else {
			qtyInputVal--;
			qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
		}

		if (qtyInputVal >= 1) {
			updateCartItemQuantity(lineKey, qtyInputVal);
		} else {
			updateCartItemQuantity(lineKey, 0);
		}
	});

	// MAIN CART REMOVE
	$('.actions .remove-product').on('click', function (e) {
		e.preventDefault();
		var $this = $(this);
		var lineID = $this.closest('.cart-row').attr('data-lineid');
		var lineKey = $this.closest('.cart-row').attr('data-key');

		updateCartItemQuantity(lineKey, 0);
	});

	/******************************************
    Options to change SM-RC Widget dropdowns
   ******************************************/

	// SELECT TYPE
	$('body').on('change', '.option__wrap select', function () {
		var optionVal = $(this).val();
		var optionNum = $(this).closest('.option__wrap').attr('data-option');

		$('select[' + optionNum + ']')
			.val(optionVal)
			.change();
	});

	// BUTTON TYPE
	$('body').on('click', '.option__wrap button', function (e) {
		var optionVal = $(this).attr('data-val');
		var optionNum = $(this).closest('.option__wrap').attr('data-option');

		if ($(this).hasClass('btn--swatch')) {
			$(this).closest('.option__wrap').find('.color-val').text(optionVal);
		}

		// Set visual display of active
		$(this).closest('.option__wrap').find('button').removeClass('active');
		$(this).addClass('active');

		$('select[' + optionNum + ']')
			.val(optionVal)
			.change();
	});

	// RECHARE WIDGET VARIANTS
	$('.pdp__recharge input').on('click', function () {
		if ($(this).val() == 'rc-yes') {
			$('.form__group--rc').show();
			var planId = $(this)
				.closest('.pdp__recharge')
				.find('.frequency-select')
				.val();
			$('[sm-rc-plan-selector]').val(planId).change();
		} else {
			$('.form__group--rc').hide();
			$('[sm-rc-plan-selector]').val('false').change();
		}
	});

	// RECHARE WIDGET SUBSCRIPTION PLAN
	$('.template__product .frequency-select').on('change', function () {
		var planId = $(this).val();
		$('[sm-rc-plan-selector]').val(planId).change();
	});
});
